module.exports = __webpack_public_path__ + "static/media/checkbox-default.53fda9dd.svg";